// extracted by mini-css-extract-plugin
export var categoryProduct = "br11-8a";
export var categoryProductImg = "br11-9a";
export var categoryProductImgColors = "br11-ab";
export var categoryProductName = "br11-bb";
export var categoryProductOrigin = "br11-cb";
export var categoryProductPriceCn = "br11-db";
export var categoryProductPriceEn = "br11-eb";
export var categoryProductSaleView = "br11-hb";
export var categoryProductTag = "br11-fb";
export var categoryProductTagLine = "br11-gb";